import MaskedInput from 'react-text-mask';
import {phoneNumberMask} from '../../../../constants/constants';

const PhoneInput = ({inputRef, ...other}) => (
  <MaskedInput
    {...other}
    ref={inputRef}
    mask={phoneNumberMask}
  />
);

export default PhoneInput;
